var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAlertUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spoj9htj2a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u4npolls2b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2387"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 92",
    d: "M48.5 5a43.513 43.513 0 0 0-16.931 83.584A43.513 43.513 0 0 0 65.431 8.416 43.223 43.223 0 0 0 48.5 5m0-5A48.5 48.5 0 1 1 0 48.5 48.5 48.5 0 0 1 48.5 0z",
    style: {
      fill: "url(#spoj9htj2a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M5618.3 306.633v37.009",
    transform: "translate(-5569.016 -283.641)",
    style: {
      fill: "url(#u4npolls2b)",
      stroke: "#5b5b5b",
      strokeLinecap: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3346",
    d: "M0-1h38.083",
    transform: "translate(29.5 75.919)",
    style: {
      fill: "url(#u4npolls2b)",
      stroke: "#5b5b5b",
      strokeLinecap: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3074",
    d: "m23193.727 97.816 21.914-19.589",
    transform: "translate(-23167.717 -55.235)",
    style: {
      fill: "none",
      stroke: "#5b5b5b",
      strokeLinecap: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3075",
    d: "m23215.641 97.816-21.914-19.589",
    transform: "translate(-23143.806 -55.235)",
    style: {
      fill: "none",
      stroke: "#5b5b5b",
      strokeLinecap: "round",
      strokeWidth: 5
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlertUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-alertUpload.49ef9ac198dc4fffb884f438c8b24cf5.svg";